fragment RoutineFiftyFiftyTeaserWithBulletsFragment on routineFiftyFiftyTeaserWithBullets_Entry {
  typeHandle
  routine {
    ...RoutinePreviewFragment
  }
  image {
    url
  }
  alt
  body
  ctaText
  position
}
